import { createStore, type ReadOnlyStore } from "@observe-tech/mfe-shell-api";

export interface MfeErrorState {
  appName: string;
  message: string;
  loadFailed: boolean;
}

export interface MfeErrorApi {
  state: ReadOnlyStore<MfeErrorState | null>;
  set(appName: string, err: unknown, loadFailed?: boolean): void;
  clear(): void;
}

export function createMfeErrorApi(): MfeErrorApi {
  const handle = createStore<MfeErrorState | null>(null);
  return {
    state: handle.store,
    set(appName, err, loadFailed = false) {
      const message =
        err instanceof Error
          ? err.message
          : typeof err === "string"
            ? err
            : "Unknown error";
      handle.set({ appName, message, loadFailed });
    },
    clear() {
      handle.set(null);
    },
  };
}
